module.exports = __webpack_public_path__ + "static/media/resume.25c02d3d.pdf";